import { Text } from '../../../shared-components';
import { Box } from '../../../shared-components/Box';
import { QR } from '../../../shared-components/QR';
import { container } from '../../../shared-components/shared-styles';
import { colors } from '../../../shared-components/styles';

export const QRComponent = ({ Icon, title, description, links, size = 120 }) => {
  return (
    <Box
      flex="space-between"
      css={`
        flex-grow: 1;
        ${container.box}
        box-sizing: border-box;
        margin: 8px;
        padding: 8px;
        svg {
          min-width: 32px;
        }
      `}
    >
      <Box
        flex="left wrap"
        css={`
          gap: 16px;
          flex-grow: 1;
          max-width: calc(100% - ${size + 32}px);
          padding-left: 16px;
        `}
      >
        <Icon size={32} color="var(--button-background-color)" />
        <Box
          css={`
            min-width: 200px;
            flex-grow: 1;
          `}
        >
          <Text h4>{title}</Text>
          <Text label wrap>
            {description}
          </Text>
        </Box>
      </Box>
      <Box
        flex="right"
        css={`
          gap: 8px;
        `}
      >
        {links?.map(({ url, centerImageSrc }) => (
          <Box
            key={url}
            css={`
              background-color: ${colors.gray[600]};
              border-radius: 8px;
            `}
          >
            <QR data={url} height={size} width={size} centerImageSrc={centerImageSrc} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};
